import $ from 'jquery';


import Vue from 'vue';
import Fancafe from './Fancafe.vue';
import { store } from './store/fancafe.js';

new Vue({
	el: '#daumContent',
	store,
	render: h => h(Fancafe)
});

window.fancafeList = (function ($) {
	function init() {
		initHandlebars();
		setEvents();
		getPannList();

	}

	function initHandlebars() {
		cafe.handlebars.helper.registerEncodeURIComponent();
		cafe.handlebars.helper.registerCompare();
		cafe.handlebars.helper.math();
	}
	
	function setEvents() {
		$("#link_top").on("click", function (e) {
			e.preventDefault();
			$(window).scrollTop(0)
		})
	}
	
	function getPannList() {
		$.ajax({
			url: "/_c21_/api/v3/fancafe/pann",
			data: { count: 10 },
		}).then(function (res) {
			let contents;

			switch(res.type) {
				case 'fanMagazine':
					contents = res.contents.slice(0, 5);
					break;
				case 'fandomRanking': case 'cheerRanking': case 'cafeRanking':
					contents = res.contents;
					break;

				case 'banner': default:
					contents = [];
					break;
			}
			fancafeSlider.init(contents);
		});
	}
	
	return {
		init: init
	}
})($);

window.fancafeSlider = (function ($) {
	var started = false;

	var sliderWrap, sliderInner;
	var iWidth = 0;
	var cWidth = 520;
	var sliderShowCount = 5;
	var stopSliding = false;
	var sliderData;
	var length;
	var isAnimationStarted = false;

	function init(data) {
		if (started) return false;
		sliderData = data;
		length = sliderData.length;
		started = true;
		initHandlebars();
		cacheElements();
		renderSlider();
	}

	function initHandlebars() {
		cafe.handlebars.helper.registerEncodeURIComponent();
		cafe.handlebars.helper.registerCompare();
		cafe.handlebars.helper.math();
	}

	function renderSlider() {
		expandData();
		generatePann();
		setEvents();
		adjustSliderWidth();
		reBuildItems();
		startSliding();
	}

	function cacheElements() {
		sliderWrap = $("#fancafe_pann_wrap");
		sliderInner = $("#fancafe_pann");
	}

	function setEvents() {
		$(document.body).on("mouseover", ".feature_fancafe", function () {
			stopSliding = true;
		});
		$(document.body).on("mouseout", ".feature_fancafe", function () {
			stopSliding = false;
		});

		sliderWrap.on("click", "#getNext", getNext);
		sliderWrap.on("click", "#getPrev", getPrev);
	}

	function generatePann() {
		var temp = Handlebars.compile($.trim($("#pann-template").html()));
		sliderInner.html(temp(
			sliderData.map(v => ({ ...v, length: length }))
		));
	}

	function adjustSliderWidth() {
		var sliderItems = sliderInner.find(".slick-slide").get();
		var w = sliderWrap.width();
		iWidth = (w - cWidth) / (sliderShowCount - 1);
		var totalWidth = (cWidth / 2) * (length - 1) * 3 + cWidth;
		sliderInner.css("width", totalWidth);
		sliderInner.css("left", -(iWidth * (length - 2)));
		for (var i = 0; i < sliderItems.length; i++) {
			sliderItems[i].style.width = iWidth + "px";
		}
	}

	function reBuildItems(num) {
		var newlist = $("#fancafe_pann").find(".slick-slide");
		var centerItem = $(newlist[length]);
		if (num) {
			var oldItem = $(newlist[num]);
			$("#fancafe_pann").find(".slick-current").removeClass("slick-current").animate({"opacity": 0.6, "width": iWidth}, 500, function () {

			});
			oldItem.addClass("slick-current");
			oldItem.animate({"opacity": 1, "width": cWidth}, 500, function () {
				$("#slideData").html($(newlist[num]).find(".slick-data").html());
			});
		} else {
			centerItem.addClass("slick-current").width(cWidth);
			$("#slideData").html($(newlist[length]).find(".slick-data").html());
		}
	}

	function expandData() {
		var dummy = sliderData;
		sliderData = sliderData.concat(dummy).concat(dummy);
	}

	function shiftSlider() {
		var wrap = $("#fancafe_pann");
		var tempLi = wrap.find(".slick-slide:first-child");
		wrap.remove(".slick-slide:first-child");
		wrap.append(tempLi);
	}

	function unshiftSlider() {
		var wrap = $("#fancafe_pann");
		var tempLi = wrap.find(".slick-slide:last-child");
		wrap.remove(".slick-slide:last-child");
		wrap.prepend(tempLi);
	}

	function getNext() {
		if (isAnimationStarted) return;
		isAnimationStarted = true;
		var s = parseInt(sliderInner.css("left")) - iWidth;
		sliderInner.animate({"left": s}, 500, function () {
			shiftSlider();
			sliderInner.css("left", -(iWidth * (length - 2)));
		});
		$("#slideData").fadeOut(500).fadeIn(500, () => {
			isAnimationStarted = false;
		});

		var c = $("#fancafe_pann").find(".slick-current");
		var l = $("#fancafe_pann").find(".slick-slide");
		$(c).animate({"opacity": 0.6, "width": iWidth}, "slow", function () {
			c.removeClass("slick-current");
		});
		$(l[length + 1]).animate({"opacity": 1, "width": cWidth}, "slow", function () {
			$(this).addClass("slick-current");
			$("#slideData").html($(this).find(".slick-data").html());
		});
	}

	function getPrev() {
		if (isAnimationStarted) return;
		isAnimationStarted = true;
		var s = parseInt(sliderInner.css("left")) + iWidth;
		sliderInner.animate({"left": s}, 500, function () {
			unshiftSlider();
			sliderInner.css("left", -(iWidth * (length - 2)));
		});
		$("#slideData").fadeOut(500).fadeIn(500, () => {
			isAnimationStarted = false;
		});

		var c = $("#fancafe_pann").find(".slick-current");
		var l = $("#fancafe_pann").find(".slick-slide");
		$(c).animate({"opacity": 0.6, "width": iWidth}, "slow", function () {
			c.removeClass("slick-current");
		});
		$(l[length - 1]).animate({"opacity": 1, "width": cWidth}, "slow", function () {
			$(this).addClass("slick-current");
			$("#slideData").html($(this).find(".slick-data").html());
		});

	}

	function startSliding() {
		window.setInterval(function () {
			if (!stopSliding) {
				getNext();
			}
		}, 3000);
	}

	return {
		init: init
	}
})($);

Handlebars.registerHelper("remainderIndex", function (objectNum, divideNum, addNum) {
	var num = (objectNum % divideNum);
	if (addNum) num += addNum;
	return num;
});
Handlebars.registerHelper("formatDate", function (num) {
	var ymdhm = convertDate(new Date(num));

	function convertDate(date) {
		function pad2(n) {
			return (n < 10 ? "0" : "") + n;
		}

		return date.getFullYear() + "." +
			pad2(date.getMonth() + 1) + "." +
			pad2(date.getDate()) + " " +
			pad2(date.getHours()) + ":" +
			pad2(date.getMinutes()) + ":" +
			pad2(date.getSeconds());
	}

	return ymdhm;
});

(function () {
	if (typeof TiaraTracker === 'undefined') return;

	var tiaraInstance = TiaraTracker.getInstance();

	tiaraInstance.setSvcDomain('cafe.daum.net')
		.setSection('top')
		.setPage('fan_cafe')
		.setSessionTimeout('1800')
		.setDeployment(IS_DEV ? 'dev' : 'production')
		.setIgnoreQueryParams(['ts', 'dummy'])
		.trackPage('fan_cafe')
		.track();

	var trackEvent = function (option) {
		var url = option.url || '';

		var clickObject = {
			layer1: option.layer,
			layer2: '',
			layer3: '',
			click_url: url.slice(0, 255),
			copy: '',
			posx: 0,
			posy: 0
		};

		tiaraInstance
			.trackEvent('카페탑>팬카페>' + option.desc)
			.click(clickObject)
			.customProps(option.customProps)
			.track();
	};

	$('#slideData').on('click', function () {
		trackEvent({layer: 'recommend_fan_cafe', desc: '상단 추천 팬카페'});
	}).find('.link_slide');

	$('#cSub').find('.snb_fancafe .list_snb').on('click', function () {
		trackEvent({layer: 'cafe_sorting_option', desc: '팬카페 정렬'});
	});

	$('#optCategory_layer').find('li').on('click', function () {
		trackEvent({layer: 'category_sorting_option', desc: '분야별 보기 옵션'});
	});

	$('#optTime_layer').find('li').on('click', function () {
		trackEvent({layer: 'time_sorting_option', desc: '시간별 보기'});
	});

	$('#optStars_layer').find('.txt_selected').on('click', function () {
		trackEvent({layer: 'star_cafe_btn', desc: '스타가 가입한 팬카페 버튼'});
	});

	$('#searchStarBtn').on('click', function () {
		trackEvent({layer: 'star_cafe_search', desc: '스타가 가입한 카페 검색 버튼'});
	});

	$('#starJoinCafeList').on('click', function () {
		trackEvent({layer: 'star_cafe_title', desc: '스타가 가입한 카페 목록'});
	}).find('.link_item');

	$('#fandomeTop10List, #fandomeRankListView').on('click', function () {
		trackEvent({layer: 'fan_cafe_title', desc: '팬카페 목록'});
	}).find('.fancafe_linknail, .fancafe_link');

	$('#mArticle').find('.link_fancafebnr').on('click', function () {
		trackEvent({layer: 'noti_banner', desc: '팬카페 공지 배너'});
	});

	$('#btn_morelist').on('click', function () {
		trackEvent({layer: 'fan_cafe_more_btn', desc: '팬카페 더보기 버튼'});
	});
})();

$(function () {
	window.fancafeList.init();
});
